module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Oops! Looks like you tried to log in to an app for which you aren’t a user.","description":"Access {link} to select a different app","logout":"Or try {link} as a different user","accountCentral":"account central","loggingIn":"logging in"}}')
  delete Component.options._Ctor
}
